import { Card, Checkbox } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

import styles from './index.less';

const TrlKeys = {
    ariaLabel: 'resume.card.action.selectCard.ariaLabel',
};

interface Props {
    isSelected: boolean;
    select: () => void;
}

const SelectCardButton: TranslatedComponent<Props> = ({ isSelected, select, trls }) => {
    return (
        <Card
            padding={8}
            borderRadius={12}
            style="secondary"
            onClick={select}
            data-qa="resume-card-action resume-card-action_select"
        >
            <div className={styles.cardWithCheckbox}>
                <Checkbox checked={isSelected} onChange={select} aria-label={trls[TrlKeys.ariaLabel]} tabIndex={-1} />
            </div>
        </Card>
    );
};

export default translation(SelectCardButton);
